import { partners } from "./data/index";
const OurPartners = () => {
  return (
    <div className="bg-[#029875] py-10 ">
      <div className="flex items-center flex-col gap-5 md:gap-10 max-w-6xl px-5 mx-auto">
        <p className="text-white text-2xl md:text-3xl font-bold">
          Our Partners
        </p>
        <div className="flex items-center gap-5 flex-wrap justify-center">
          {partners.map((img, idx) => {
            return (
              <div key={idx}>
                <img src={img} alt="image" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default OurPartners;
